import { hasPermission } from '@/hooks/useBackendMenu'
import { TipoOcorrencia, zod } from '@acme/core'
import { match } from 'ts-pattern'
import { z } from 'zod'
import ApiService from '../api.service'

export type Ocorrencia = z.infer<typeof zod.OcorrenciaSchema> & {
    /** Verdadeiro quando o usuário não tem permissão */
    disabled?: boolean
}

export const createOcorrenciaSchema = zod.OcorrenciaSchema.omit({
    updatedAt: true,
    createdAt: true,
    deletedAt: true,
}).partial({
    id: true,
    clienteId: true,
    codigo: true,
    atalho: true,
    qntHrsCompensadasNaSemana: true,
    feriadoNaSemana: true,
    somarAusenciasInjustificadas: true,
    somarAusenciasJustificadas: true,
    somarHorasTrabalhadas: true,
})

export const updateOcorrenciaSchema = createOcorrenciaSchema.required({
    id: true,
    clienteId: true,
})

const service = new ApiService<Ocorrencia>('ocorrencias')

export const ocorrencia = Object.assign(service, {
    desativadas: new ApiService<Ocorrencia>('ocorrencias/desativadas'),
})

export function ocorrenciaTipoToPermission(
    tipo: Ocorrencia['tipo'] | 'REGISTRO' | 'ABONO',
) {
    return match(tipo)
        .with(TipoOcorrencia.AFASTAMENTO, () => 'Afastamentos' as const)
        .with(TipoOcorrencia.AMAMENTACAO, () => 'Amamentação' as const)
        .with(TipoOcorrencia.COMPENSACAO, () => 'Compensação' as const)
        .with(TipoOcorrencia.FOLGA, () => 'Folga' as const)
        .with('REGISTRO', () => 'Registros' as const)
        .with('ABONO', () => 'Abonos' as const)
        .otherwise(() => {
            throw new Error(
                `Tipo de ocorrência ${tipo} não mapeado para permissão`,
            )
        })
}

export function hasPermissionToAnyAfastamento(
    whichPermission: 'create' | 'update' | 'delete',
) {
    return Object.values(TipoOcorrencia).some(tipo =>
        hasPermission([whichPermission, ocorrenciaTipoToPermission(tipo)]),
    )
}

export function hasPermissionAjustes() {
    return (
        hasPermission(['update', 'Registros']) ||
        hasPermission(['update', 'Abonos']) ||
        hasPermissionToAnyAfastamento('update')
    )
}
